import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['RecommendTrip'],
});
export const recommendTripApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllRecommendTrip: builder.query({
      query: () => `recommend_trip/`,
      providesTags: ['RecommendTrip'],
    }),

    findAllInvalidRecommendTrip: builder.query({
      query: () => `recommend_trip/?is_valid=false`,
      providesTags: ['RecommendTrip'],
    }),

    findAllRecommendTripByPagination: builder.query({
      query: (payload) => {
        let url = `recommend_trip/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);

        return { url: `${url}?${searchParams.toString()}` };
      },
    }),

    findAllRecommendTripBySelection: builder.query({
      query: (id) => `recommend_trip/selection_data/?calling_unit=${id}`,
      providesTags: ['RecommendTrip'],
    }),
    findAllRecommendTripByMatchCalling: builder.query({
      query: (data) =>
        `recommend_trip/match_calling/?calling_id=${data.calling_id}&dispatch_board_id=${data.dispatch_board_id}`,
      providesTags: ['RecommendTrip'],
    }),
    findAllRecommendTripByCalling: builder.query({
      query: (id) => `recommend_trip/calling/${id}`,
      providesTags: ['RecommendTrip'],
    }),

    findAllRecommendTripNumberCalling: builder.query({
      query: (payload) => {
        let url = `recommend_trip/number_calling/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
    }),

    findRecommendTripById: builder.query({
      query: (id) => `recommend_trip/${id}/`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'RecommendTrip', id: result.id }]
          : ['RecommendTrip'];
      },
    }),
    findRecommendTripByNo: builder.query({
      query: (no) => `recommend_trip/scan_at_yardout/?RecommendTrip_no=${no}`,
      providesTags: ['RecommendTrip'],
    }),
    findRecommendTripCallingCompleteCount: builder.query({
      query: () => {
        let url = `RecommendTrip/count_calling_complete/`;
        return { url };
      },
      keepUnusedDataFor: 0,
      providesTags: ['RecommendTrip'],
    }),
    createRecommendTrip: builder.mutation({
      query: (region) => ({
        url: `RecommendTrip/`,
        method: 'POST',
        body: region,
      }),
      invalidatesTags: ['RecommendTrip'],
    }),
    updateRecommendTrip: builder.mutation({
      query: (region) => ({
        url: `RecommendTrip/${region.id}/`,
        method: 'PATCH',
        body: region,
      }),
      invalidatesTags: ['RecommendTrip'],
    }),
    deleteRecommendTrip: builder.mutation({
      query: (region) => ({
        url: `RecommendTrip/${region.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['RecommendTrip'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllRecommendTripQuery,
  useFindAllInvalidRecommendTripQuery,
  useFindRecommendTripByIdQuery,
  useFindAllRecommendTripBySelectionQuery,
  useFindAllRecommendTripByMatchCallingQuery,
  useFindAllRecommendTripByCallingQuery,
  useFindRecommendTripCallingCompleteCountQuery,
  useFindRecommendTripByNoQuery,
  useCreateRecommendTripMutation,
  useUpdateRecommendTripMutation,
  useDeleteRecommendTripMutation,
} = recommendTripApi;
